const DEFAULT_MANAGE_STATUS_ERROR_MESSAGE =
  'No pudimos procesar la suscripcion. Verifique los datos de pago e intente nuevamente.';

const EXPIRED_CREDIT_CARD_ERROR_MESSAGE =
  'La tarjeta de credito esta vencida. Verifique la fecha de expiracion o use otra tarjeta.';

export function getManageStatusErrorMessage(error: unknown): string {
  const message = getErrorText(error);
  const normalizedMessage = normalizeText(message);

  if (normalizedMessage.includes('tarjeta de credito vencida')) {
    return EXPIRED_CREDIT_CARD_ERROR_MESSAGE;
  }

  if (isTechnicalManageStatusError(message, normalizedMessage)) {
    return DEFAULT_MANAGE_STATUS_ERROR_MESSAGE;
  }

  return message || DEFAULT_MANAGE_STATUS_ERROR_MESSAGE;
}

function getErrorText(error: unknown): string {
  if (typeof error === 'string') {
    return error.trim();
  }

  if (!error || typeof error !== 'object') {
    return '';
  }

  const errorObject = error as { error?: unknown; message?: unknown };

  if (typeof errorObject.error === 'string') {
    return errorObject.error.trim();
  }

  if (errorObject.error && typeof errorObject.error === 'object') {
    const nestedError = errorObject.error as { message?: unknown };

    if (typeof nestedError.message === 'string') {
      return nestedError.message.trim();
    }
  }

  if (typeof errorObject.message === 'string') {
    return errorObject.message.trim();
  }

  return '';
}

function normalizeText(value: string): string {
  return value
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase();
}

function isTechnicalManageStatusError(message: string, normalizedMessage: string): boolean {
  return (
    normalizedMessage.includes('managesuscription') ||
    normalizedMessage.includes('managesubscription') ||
    normalizedMessage.includes('error al intentar procesar esta suscripcion') ||
    normalizedMessage.includes('con esta excepcion') ||
    normalizedMessage.includes('java.lang.') ||
    message.includes('\tat ')
  );
}
